import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { RedeemActions } from 'features'

const CheckAllowance = (): JSX.Element | null => {
  const dispatch = useDispatch()

  useEffect(() => {
    const isReward = window.location.pathname.includes('reward')
    if (isReward) {
      dispatch(RedeemActions.checkRewardAllowanceRequest())
    } else {
      dispatch(RedeemActions.checkEventAllowanceRequest())
    }
  }, [dispatch])

  return null
}

export { CheckAllowance }
